// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WhyHostFormBlock5-space1-y1ZIn {
	margin-bottom: 6px !important;
}

.WhyHostFormBlock5-space2-UAAC9 {
	margin-bottom: 12px !important;
}

.WhyHostFormBlock5-space3-Ljwqj {
	margin-bottom: 18px !important;
}

.WhyHostFormBlock5-space4-Oak4H {
	margin-bottom: 24px !important;
}

.WhyHostFormBlock5-space5-nB0Rw {
	margin-bottom: 30px !important;
}

.WhyHostFormBlock5-space6-Rn86a {
	margin-bottom: 36px !important;
}

.WhyHostFormBlock5-space7-IbjPE {
	margin-bottom: 42px !important;
}

.WhyHostFormBlock5-space8-WsXuR {
	margin-bottom: 48px !important;
}

.WhyHostFormBlock5-spaceTop1-auhzR {
	margin-top: 6px !important;
}

.WhyHostFormBlock5-spaceTop2-zpLLI {
	margin-top: 12px !important;
}

.WhyHostFormBlock5-spaceTop3-C5Opx {
	margin-top: 18px !important;
}

.WhyHostFormBlock5-spaceTop4-LhcwD {
	margin-top: 24px !important;
}

.WhyHostFormBlock5-spaceTop5-C0epd {
	margin-top: 30px !important;
}

.WhyHostFormBlock5-spaceTop6-RTtiv {
	margin-top: 36px !important;
}

.WhyHostFormBlock5-spaceTop7-dLiaM {
	margin-top: 42px !important;
}

.WhyHostFormBlock5-spaceTop8-kK6Lt {
	margin-top: 48px !important;
}

.WhyHostFormBlock5-noMargin-s0n1P {
	margin: 0px !important;
}

.WhyHostFormBlock5-padding1-E_qJZ {
	padding-bottom: 6px !important;
}

.WhyHostFormBlock5-padding2-AcK4f {
	padding-bottom: 12px !important;
}

.WhyHostFormBlock5-padding3-v7ht1 {
	padding-bottom: 18px !important;
}

.WhyHostFormBlock5-padding4-7Fvrk {
	padding-bottom: 24px !important;
}

.WhyHostFormBlock5-padding5-kEsab {
	padding-bottom: 30px !important;
}

.WhyHostFormBlock5-padding6-KYqcV {
	padding-bottom: 36px !important;
}

.WhyHostFormBlock5-padding7-zRNyK {
	padding-bottom: 42px !important;
}

.WhyHostFormBlock5-paddingTop1-X7FaI {
	padding-top: 6px !important;
}

.WhyHostFormBlock5-paddingTop2-Q7FOM {
	padding-top: 12px !important;
}

.WhyHostFormBlock5-paddingTop3-LM1X9 {
	padding-top: 18px !important;
}

.WhyHostFormBlock5-paddingTop4-wJVz2 {
	padding-top: 24px !important;
}

.WhyHostFormBlock5-paddingTop5-iHdFa {
	padding-top: 30px !important;
}

.WhyHostFormBlock5-paddingTop6-XiyZB {
	padding-top: 36px !important;
}

.WhyHostFormBlock5-paddingTop7-Chsld {
	padding-top: 42px !important;
}

.WhyHostFormBlock5-noPadding-k4zQ7 {
	padding: 0px !important;
}

.WhyHostFormBlock5-spaceMarginBottom0-nX5x1 {
	margin-bottom: 0;
}

.WhyHostFormBlock5-textBold-oNQPy {
	font-weight: 500 !important;
}

.WhyHostFormBlock5-textBolder-LHEtq {
	font-weight: 700 !important;
}

.WhyHostFormBlock5-textNormal-UaGXn {
	font-weight: normal !important;
}

/*New Design Text Colors */

.WhyHostFormBlock5-textDarkBlue-Dx0l7 {
	color: rgb(20, 39, 94) !important;
}

.WhyHostFormBlock5-textLightBlue-VFqCH {
	color: rgb(57, 87, 106) !important;
}

.WhyHostFormBlock5-textLightSandleGreen-HNpae {
	color: rgb(76, 86, 41) !important;
}

.WhyHostFormBlock5-textLightBrown-Wu54S {
	color: rgb(115, 79, 33) !important;
}

.WhyHostFormBlock5-textMediumMaroon-Xtxrr {
	color: rgb(87, 37, 51) !important;
}

.WhyHostFormBlock5-textBrown-m2J51 {
	color: rgb(160, 47, 24) !important;
}

.WhyHostFormBlock5-textMaroon-CdtHH {
	color: rgb(155, 49, 67) !important;
}

.WhyHostFormBlock5-textDarkBrown-YTT1s {
	color: rgb(83, 18, 16) !important;
}

.WhyHostFormBlock5-textMediumBrown-P4jBE {
	color: rgb(142, 28, 10) !important;
}

.WhyHostFormBlock5-textSkyBlue-q5Pc0 {
	color: rgb(37, 117, 141) !important;
}

.WhyHostFormBlock5-textGray-G6rga {
	color: rgb(77, 65, 51) !important;
}

.WhyHostFormBlock5-errorMessage-IzSxz {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.WhyHostFormBlock5-userText-JRASA {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.WhyHostFormBlock5-panelHeader-JjGKe {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.WhyHostFormBlock5-exportSection-b5mLt {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.WhyHostFormBlock5-exportSectionGridSub-v88VP {
	grid-template-columns: 50% 49% !important;
}

.WhyHostFormBlock5-exportText-KVCcd {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.WhyHostFormBlock5-exportLinkImg-mBMaN {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.WhyHostFormBlock5-exportImg-poG8v {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.WhyHostFormBlock5-linkBtn-iS_4O {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.WhyHostFormBlock5-table-UxkMf {
	display: table;
}

.WhyHostFormBlock5-tableRow-AYrCd {
	display: table-row;
}

.WhyHostFormBlock5-tableCell-Nay8f {
	display: table-cell;
	float: none;
}

.WhyHostFormBlock5-formGroup-hgsGy {
	margin-bottom: 6px;
}

.WhyHostFormBlock5-marginTop0-TVls_ {
	margin-top: 0;
}

.WhyHostFormBlock5-marginBottom20-sMQVQ {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.WhyHostFormBlock5-bannerImageBg-yEOWD {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.WhyHostFormBlock5-bannerDelete-PWnOV {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.WhyHostFormBlock5-exportLink-CX0D8 {
	padding-top: 10px;
	padding-right: 10px;
}

.WhyHostFormBlock5-seachContent-guNvZ {
	padding-left: 0px;
	margin-bottom: 5px;
}

.WhyHostFormBlock5-marginBottom9-wn6RR {
	margin-bottom: 9px;
}

.WhyHostFormBlock5-spaceTop52-Gg1Be {
	margin-top: 52px;
}

.WhyHostFormBlock5-profileViewInner-Ly7IT {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.WhyHostFormBlock5-profileViewMain-fs9cl {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.WhyHostFormBlock5-profileViewlabel-OMrYZ {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.WhyHostFormBlock5-profileViewMainContent-zeILP {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.WhyHostFormBlock5-reviewsFormStar-kvnwX {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.WhyHostFormBlock5-reviewsFormStar-kvnwX svg {
	cursor: pointer;
}

.WhyHostFormBlock5-addLanguageText-HQX7I {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.WhyHostFormBlock5-exportSection-b5mLt {
		grid-template-columns: 100%;
	}

	.WhyHostFormBlock5-spaceTop52-Gg1Be {
		margin-top: 18px;
	}

	.WhyHostFormBlock5-exportText-KVCcd {
		float: none;
		margin-top: 12px;
	}

	.WhyHostFormBlock5-exportSectionGridSub-v88VP {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.WhyHostFormBlock5-profileViewlabel-OMrYZ {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.WhyHostFormBlock5-profileViewMainContent-zeILP {
		width: 100%;
		text-align: center;
	}

	.WhyHostFormBlock5-panelHeader-JjGKe {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `WhyHostFormBlock5-space1-y1ZIn`,
	"space2": `WhyHostFormBlock5-space2-UAAC9`,
	"space3": `WhyHostFormBlock5-space3-Ljwqj`,
	"space4": `WhyHostFormBlock5-space4-Oak4H`,
	"space5": `WhyHostFormBlock5-space5-nB0Rw`,
	"space6": `WhyHostFormBlock5-space6-Rn86a`,
	"space7": `WhyHostFormBlock5-space7-IbjPE`,
	"space8": `WhyHostFormBlock5-space8-WsXuR`,
	"spaceTop1": `WhyHostFormBlock5-spaceTop1-auhzR`,
	"spaceTop2": `WhyHostFormBlock5-spaceTop2-zpLLI`,
	"spaceTop3": `WhyHostFormBlock5-spaceTop3-C5Opx`,
	"spaceTop4": `WhyHostFormBlock5-spaceTop4-LhcwD`,
	"spaceTop5": `WhyHostFormBlock5-spaceTop5-C0epd`,
	"spaceTop6": `WhyHostFormBlock5-spaceTop6-RTtiv`,
	"spaceTop7": `WhyHostFormBlock5-spaceTop7-dLiaM`,
	"spaceTop8": `WhyHostFormBlock5-spaceTop8-kK6Lt`,
	"noMargin": `WhyHostFormBlock5-noMargin-s0n1P`,
	"padding1": `WhyHostFormBlock5-padding1-E_qJZ`,
	"padding2": `WhyHostFormBlock5-padding2-AcK4f`,
	"padding3": `WhyHostFormBlock5-padding3-v7ht1`,
	"padding4": `WhyHostFormBlock5-padding4-7Fvrk`,
	"padding5": `WhyHostFormBlock5-padding5-kEsab`,
	"padding6": `WhyHostFormBlock5-padding6-KYqcV`,
	"padding7": `WhyHostFormBlock5-padding7-zRNyK`,
	"paddingTop1": `WhyHostFormBlock5-paddingTop1-X7FaI`,
	"paddingTop2": `WhyHostFormBlock5-paddingTop2-Q7FOM`,
	"paddingTop3": `WhyHostFormBlock5-paddingTop3-LM1X9`,
	"paddingTop4": `WhyHostFormBlock5-paddingTop4-wJVz2`,
	"paddingTop5": `WhyHostFormBlock5-paddingTop5-iHdFa`,
	"paddingTop6": `WhyHostFormBlock5-paddingTop6-XiyZB`,
	"paddingTop7": `WhyHostFormBlock5-paddingTop7-Chsld`,
	"noPadding": `WhyHostFormBlock5-noPadding-k4zQ7`,
	"spaceMarginBottom0": `WhyHostFormBlock5-spaceMarginBottom0-nX5x1`,
	"textBold": `WhyHostFormBlock5-textBold-oNQPy`,
	"textBolder": `WhyHostFormBlock5-textBolder-LHEtq`,
	"textNormal": `WhyHostFormBlock5-textNormal-UaGXn`,
	"textDarkBlue": `WhyHostFormBlock5-textDarkBlue-Dx0l7`,
	"textLightBlue": `WhyHostFormBlock5-textLightBlue-VFqCH`,
	"textLightSandleGreen": `WhyHostFormBlock5-textLightSandleGreen-HNpae`,
	"textLightBrown": `WhyHostFormBlock5-textLightBrown-Wu54S`,
	"textMediumMaroon": `WhyHostFormBlock5-textMediumMaroon-Xtxrr`,
	"textBrown": `WhyHostFormBlock5-textBrown-m2J51`,
	"textMaroon": `WhyHostFormBlock5-textMaroon-CdtHH`,
	"textDarkBrown": `WhyHostFormBlock5-textDarkBrown-YTT1s`,
	"textMediumBrown": `WhyHostFormBlock5-textMediumBrown-P4jBE`,
	"textSkyBlue": `WhyHostFormBlock5-textSkyBlue-q5Pc0`,
	"textGray": `WhyHostFormBlock5-textGray-G6rga`,
	"errorMessage": `WhyHostFormBlock5-errorMessage-IzSxz`,
	"userText": `WhyHostFormBlock5-userText-JRASA`,
	"panelHeader": `WhyHostFormBlock5-panelHeader-JjGKe`,
	"exportSection": `WhyHostFormBlock5-exportSection-b5mLt`,
	"exportSectionGridSub": `WhyHostFormBlock5-exportSectionGridSub-v88VP`,
	"exportText": `WhyHostFormBlock5-exportText-KVCcd`,
	"exportLinkImg": `WhyHostFormBlock5-exportLinkImg-mBMaN`,
	"exportImg": `WhyHostFormBlock5-exportImg-poG8v`,
	"linkBtn": `WhyHostFormBlock5-linkBtn-iS_4O`,
	"table": `WhyHostFormBlock5-table-UxkMf`,
	"tableRow": `WhyHostFormBlock5-tableRow-AYrCd`,
	"tableCell": `WhyHostFormBlock5-tableCell-Nay8f`,
	"formGroup": `WhyHostFormBlock5-formGroup-hgsGy`,
	"marginTop0": `WhyHostFormBlock5-marginTop0-TVls_`,
	"marginBottom20": `WhyHostFormBlock5-marginBottom20-sMQVQ`,
	"bannerImageBg": `WhyHostFormBlock5-bannerImageBg-yEOWD`,
	"bannerDelete": `WhyHostFormBlock5-bannerDelete-PWnOV`,
	"exportLink": `WhyHostFormBlock5-exportLink-CX0D8`,
	"seachContent": `WhyHostFormBlock5-seachContent-guNvZ`,
	"marginBottom9": `WhyHostFormBlock5-marginBottom9-wn6RR`,
	"spaceTop52": `WhyHostFormBlock5-spaceTop52-Gg1Be`,
	"profileViewInner": `WhyHostFormBlock5-profileViewInner-Ly7IT`,
	"profileViewMain": `WhyHostFormBlock5-profileViewMain-fs9cl`,
	"profileViewlabel": `WhyHostFormBlock5-profileViewlabel-OMrYZ`,
	"profileViewMainContent": `WhyHostFormBlock5-profileViewMainContent-zeILP`,
	"reviewsFormStar": `WhyHostFormBlock5-reviewsFormStar-kvnwX`,
	"addLanguageText": `WhyHostFormBlock5-addLanguageText-HQX7I`
};
module.exports = ___CSS_LOADER_EXPORT___;
